import { handleActions } from 'redux-actions';

import { SET_APP_MODE } from '../constants/index';

const initialState = {
  appMode: 'user',
};

export const app = handleActions(
  {
    [SET_APP_MODE]: (state, action = {}) => ({
      appMode: action.payload,
    }),
  },
  initialState,
);
